<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title mb-0">
                <font-awesome-icon :icon="['fas', 'vote-yea']" /> Der PARTEI-O-Mat
            </h2>
        </div>
        <div class="body p-4">
            <div class="text-center">
                <button @click="$emit('start')" class="btn btn-primary btn-lg">
                    <font-awesome-icon :icon="['far', 'play-circle']" /> Start
                </button>
            </div>
        </div>
        <div class="card-footer">
            <strong>PS</strong>: Im Gegensatz zu Google und Facebook speichern wir <strong>keine Daten</strong> über Dich. Smiley!
        </div>
    </div>
</template>

<script>
    export default {
        name: "MatStart"
    }
</script>

<style scoped>

</style>